module.exports = __webpack_public_path__ + "static/media/stalak_za_romobile.744d1670.png";